module.exports = __webpack_public_path__ + "static/media/white.a153d612.png";